import { ContentType } from '@/interfaces';

// Insight IDs are numeric and session IDs hex, which keeps pages like /events/past from matching.
const REPORT_ROUTES: Array<[RegExp, ContentType]> = [
    [/^\/insights\/(\d+)(?:\/(?:view|abstract))?\/?$/, ContentType.insight],
    [/^\/events\/([0-9a-f]+)(?:\/slides)?\/?$/, ContentType.eventsession],
    [/^\/summits\/[^/]+\/sessions\/([0-9a-f]+)(?:\/slides)?\/?$/, ContentType.eventsession],
];

/**
 * `contentType:id` for a report's page or viewer path, or null. All the paths of one report share a key, with or
 * without query parameters. The ID comes from the URL: for a single-session event it is the event ID, not the
 * stored session ID, so reports are matched by this key and not by `itemId`.
 */
export function reportKey(path: string): string | null {
    const pathname = path.split(/[?#]/, 1)[0];
    for (const [pattern, contentType] of REPORT_ROUTES) {
        const id = pathname.match(pattern)?.[1];
        if (id) return `${contentType}:${id}`;
    }
    return null;
}
